var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DOCX_ICON from '@backrs_ui/common-ui/src/assets/images/document-icons/docx_file_icon.svg';
import IMG_ICON from '@backrs_ui/common-ui/src/assets/images/document-icons/img_file_icon.svg';
import MOV_ICON from '@backrs_ui/common-ui/src/assets/images/document-icons/mov_file_icon.svg';
import MP4_ICON from '@backrs_ui/common-ui/src/assets/images/document-icons/mp4_file_icon.svg';
import PDF_ICON from '@backrs_ui/common-ui/src/assets/images/document-icons/pdf_file_icon.svg';
import TXT_ICON from '@backrs_ui/common-ui/src/assets/images/document-icons/txt_file_icon.svg';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Box, Typography } from '@mui/material';
var DocumentFileTypes = {
    PDF: '.pdf',
    DOCX: '.docx',
    TXT: '.txt',
    MP4: '.mp4',
    MOV: '.mov',
    PNG: '.png',
    JPG: '.jpg',
    JPEG: '.jpeg',
    GIF: '.gif',
};
var DocumentIconFileMap = (_a = {},
    _a[DocumentFileTypes.PDF] = PDF_ICON,
    _a[DocumentFileTypes.DOCX] = DOCX_ICON,
    _a[DocumentFileTypes.TXT] = TXT_ICON,
    _a[DocumentFileTypes.MP4] = MP4_ICON,
    _a[DocumentFileTypes.MOV] = MOV_ICON,
    _a[DocumentFileTypes.PNG] = IMG_ICON,
    _a[DocumentFileTypes.JPG] = IMG_ICON,
    _a[DocumentFileTypes.JPEG] = IMG_ICON,
    _a[DocumentFileTypes.GIF] = IMG_ICON,
    _a);
var getFileIcon = function (fileType) {
    var _a;
    var normalizedType = ((_a = fileType === null || fileType === void 0 ? void 0 : fileType.toLowerCase()) === null || _a === void 0 ? void 0 : _a.startsWith('.'))
        ? fileType === null || fileType === void 0 ? void 0 : fileType.toLowerCase()
        : ".".concat(fileType === null || fileType === void 0 ? void 0 : fileType.toLowerCase());
    return DocumentIconFileMap[normalizedType] || PDF_ICON;
};
export var UploadedFile = function (_a) {
    var fileName = _a.fileName, fileSize = _a.fileSize, fileType = _a.fileType, handleDelete = _a.handleDelete, _b = _a.borderColor, borderColor = _b === void 0 ? 'light' : _b;
    var fileIcon = getFileIcon(fileType);
    return (_jsxs(Box, { sx: uploadedFileContainerSx(borderColor), children: [_jsxs(Box, { sx: fileInfoContainerSx, children: [_jsx(Box, { sx: fileIconSx, component: "img", src: fileIcon, alt: "".concat(fileType, " file icon") }), _jsxs(Box, { overflow: "hidden", maxWidth: "100%", children: [_jsx(Typography, { variant: "text-sm-medium", noWrap: true, overflow: "hidden", color: function (theme) { return theme.backrs.colors['Gray/700']; }, children: fileName.length > 35 ? "".concat(fileName.substring(0, 35), "...") : fileName }), _jsx(Typography, { variant: "text-sm-regular", noWrap: true, overflow: "hidden", color: function (theme) { return theme.backrs.colors['Gray/600']; }, children: fileSize })] })] }), handleDelete && (_jsx(Box, { onClick: function (e) {
                    e.stopPropagation();
                    handleDelete(fileName);
                }, sx: deleteContainerSx, children: _jsx(AppIcon, { iconName: "Trash01", diameter: "16px", color: 'Gray/400' }) }))] }));
};
var fileInfoContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        gap: backrs.spacing['spacing-lg'],
        overflow: 'hidden',
    });
};
var deleteContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        padding: backrs.spacing['spacing-md'],
        paddingTop: backrs.spacing['spacing-none'],
        cursor: 'pointer',
    });
};
var fileIconSx = {
    width: '40px',
    height: '40px',
};
var uploadedFileContainerSx = function (borderColor) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            display: 'flex',
            padding: backrs.spacing['spacing-xl'],
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: backrs.spacing['spacing-xs'],
            borderRadius: backrs.radius['radius-xl'],
            border: "1px solid ".concat(backrs.colors[borderColor === 'light' ? 'Gray/200' : 'Colors/Foreground/fg-quaternary-hover']),
            background: backrs.colors['Colors/Base/White'],
            width: '100%',
            maxWidth: '70vw',
        });
    };
};
